<p-table
  #dt2
  [value]="entertainmentRewards"
  dataKey="id"
  [rows]="10"
  styleClass="p-datatable-users p-datatable-striped"
  [globalFilterFields]="['coupon', 'stars', 'description']"
  [scrollable]="true"
  scrollHeight="1000px"
  [tableStyle]="{ 'min-width': '50rem' }"
>
  <ng-template pTemplate="caption">
    <div class="flex">
      <span class="p-input-icon-right to-right">
        <p-button
          label="Add Reward"
          icon="pi pi-user"
          styleClass="p-button-success"
          iconPos="right"
          (onClick)="showAddReward()"
        ></p-button>
        <i class="pi pi-search to-right"></i>
        <input
          pInputText
          type="text"
          (input)="dt2.filterGlobal($any($event.target).value, 'contains')"
          placeholder="Search keyword"
        />
      </span>
    </div>
  </ng-template>
  <ng-template pTemplate="header">
    <tr>
      <th id="couponCode" class="table-col-width-small">
        <div class="p-d-flex p-jc-between p-ai-center">Coupon Code</div>
      </th>
      <th id="created" class="table-col-width-small">
        <div class="p-d-flex p-jc-between p-ai-center">Stars</div>
      </th>
      <th id="expiration" class="table-col-width-small">
        <div class="p-d-flex p-jc-between p-ai-center">Description</div>
      </th>
      <th id="status" class="table-col-width-small">
        <div class="p-d-flex p-jc-between p-ai-center">Status</div>
      </th>
      <th id="actions" class="table-col-width-large">
        <div class="p-d-flex p-jc-between p-ai-center">Actions</div>
      </th>
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-reward>
    <tr>
      <td>
        <span>{{ reward.coupon }}</span>
      </td>
      <td>
        <span>{{ reward.stars }}</span>
      </td>
      <td>
        <span>{{ reward.description }}</span>
      </td>
      <td>
        <span>{{ reward.isActive | status }}</span>
      </td>

      <td>
        <p-button
          label="Edit"
          styleClass="p-button-warning p-button-sm"
          icon="pi pi-file-edit"
          iconPos="right"
          (onClick)="showEditReward(reward)"
        ></p-button>
        <p-button
          *ngIf="reward.isActive"
          label="Disable"
          styleClass="p-button-danger p-button-sm"
          icon="pi pi-lock"
          iconPos="right"
          (onClick)="swapEnableReward(reward)"
        ></p-button>
        <p-button
          *ngIf="!reward.isActive"
          label="Enable"
          styleClass="p-button-primary p-button-sm"
          icon="pi pi-lock-open"
          iconPos="right"
          (onClick)="swapEnableReward(reward)"
        ></p-button>
        <p-button
          label="Delete"
          styleClass="p-button-danger p-button-sm"
          icon="pi pi-trash"
          iconPos="right"
          (onClick)="showDeleteReward(reward)"
        ></p-button>
      </td>
    </tr>
  </ng-template>
  <ng-template pTemplate="emptymessage">
    <tr>
      <td colspan="7">No Rewards found.</td>
    </tr>
  </ng-template>
</p-table>
